import React, { useEffect, useRef } from 'react';

function ToolTip({ content, setOpenToolTip }) {
  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref?.current && !ref?.current.contains(event.target)) {
        setOpenToolTip && setOpenToolTip();
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setOpenToolTip, ref]);
  return (
    <div
      style={{
        width: '200px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.3)',
        position: 'absolute',
        top: '0',
        right: '0',
        padding: '0px 15px 15px 15px',
        height: '150px',
        overflowY: 'scroll',
        overflowX: 'hidden',
        zIndex: '1',
      }}
    >
      <div ref={ref} style={{ padding: '5px 0px' }}>
        {/* <span className="" onClick={() => setOpenToolTip(false)}>
          X
        </span> */}
        <div>{content}</div>
      </div>
    </div>
  );
}

export default ToolTip;
